module.exports = __webpack_public_path__ + "static/media/graph.79ef73cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/graph.svg
// module id = 1067
// module chunks = 0